import { BehaviorSubject } from 'rxjs';
import { Route, withRouter, useHistory  } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
//import config from 'config';
import { handleResponse } from '../_helpers';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const authenticationService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: "{\"email\":\"" + username + "\",\"password\":\"" + password + "\"}"
        //body: JSON.stringify({ username, password })
    };
    /*https://localhost:5001*/
    return fetch('/api/v1/identity/login', requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            console.log(user);
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);

            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
    /*
    const { from } = this.props.location.state || { from: { pathname: "/login" } };
    this.props.history.push(from);
    this.props.history.push('/login');
    */
}
